// extracted by mini-css-extract-plugin
module.exports = {"root":"root--1g1Mg-rYXw","path":"path--2G4SQX0dnX","trail":"trail--Ntxys08m0j","text":"text--1V5WChcGGD","background":"background--1CHEUtFG-9"};